import { render } from "./RoomModal.vue?vue&type=template&id=30b9db4d&scoped=true&ts=true"
import script from "./RoomModal.vue?vue&type=script&lang=ts"
export * from "./RoomModal.vue?vue&type=script&lang=ts"

import "./RoomModal.vue?vue&type=style&index=0&id=30b9db4d&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b9db4d"]])

export default __exports__